import { jwtDecode } from 'jwt-decode';
import { getEncryptedCookies } from './cookies';

export const getToken = () => {
	return localStorage.getItem('token') ?? '';
};

export const actions = () => {
	const action = JSON.parse(getEncryptedCookies('permisos'));
	return action;
};

export const hasPermission = (nameAction) => { 
	const token = getToken();
	if (!token) return false;
	
	const decoded = jwtDecode(token);
	const action = actions();

	const actionValue = action[nameAction]; // DocumentosJurEditar

	if (actionValue) {
			// Si el nameAction está presente en action, verificar si está presente en decoded.acciones
			return decoded?.acciones?.includes(actionValue);
	} else {
			// Si el nameAction no se encuentra en action, devolver falso
			return false;
	}
};

export const hashSha256 = async (value) => {
  const utf8 = new TextEncoder().encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};

export const hashSha1 = async (value) => {
  const utf8 = new TextEncoder().encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-1', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};
